import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useCompare } from "@/context/CompareContext";

const WHATSAPP_NUMBER = "40746184905";
const WHATSAPP_MESSAGE = encodeURIComponent("Salut! Sunt interesat de o mașină de la KRZZ Auto. Îmi poți da mai multe detalii?");

export const WhatsAppFloat = () => {
  const location = useLocation();
  const { compareList } = useCompare();
  
  // Hide on admin pages
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
  const hasCompareItems = compareList.length > 0;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className={`fixed right-6 z-30 w-16 h-16 bg-[#25D366] text-white flex items-center justify-center rounded-2xl shadow-lg shadow-[#25D366]/30 hover:scale-110 hover:shadow-xl hover:shadow-[#25D366]/40 transition-all duration-300 animate-pulse-soft ${hasCompareItems ? 'bottom-24 sm:bottom-6' : 'bottom-6'}`}
      aria-label="Contact WhatsApp"
    >
      <MessageCircle className="w-7 h-7" fill="white" />
    </a>
  );
};